'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    /**
     *  update shopping cart content
     */
    UPDATE: 'CART_UPDATE',

    // submit_changes or load_date failed
    UPDATE_FAILED: 'CART_UPDATE_FAILED',

    // adding new item to shopping cart or updating existing
    CHANGE_AMOUNT: 'CART_CHANGE_AMOUNT',

    LOAD_DATA: 'CART_LOAD_DATA',

    // send changes to server
    SUBMIT_CHANGES: 'CART_SUBMIT_CHANGES',

    // can discard changes for single product (or all pending changes)
    //DISCARD_CHANGES: 'CART_DISCARD_CHANGES',

    EMPTY: 'CART_EMPTY',

    ORDERING: 'CART_ORDERING',

    ORDERED: 'CART_ORDERED',

    ORDER_FAILED: 'CART_ORDER_FAILED',

    OPTIONS_CHANGED: 'CART_OPTIONS_CHANGED',

    OPTIONS_SAVING: 'CART_OPTIONS_SAVING',

    OPTIONS_SAVING_FAILED: 'CART_OPTIONS_SAVING_FAILED',

    OPTIONS_SAVED: 'CART_OPTIONS_SAVED',

    SETTING_COUPON: 'CART_SETTING_COUPON',

    COUPON_SET: 'CART_COUPON_SET',

    REMOVE_COUPON: 'CART_REMOVE_COUPON',

    CHANGE_STEP: 'CART_CHANGE_STEP',

    CUSTOMER_CHANGE_ROUNDTRIP: 'CUSTOMER_CHANGE_ROUNDTRIP',

    CHANGE_NOTE: 'CART_CHANGE_NOTE',

    SET_PROCESSING: 'SET_PROCESSING',

    FREE_PRODUCT_SET: 'CART_FREE_PRODUCT_SET',

    DELIVERY_CHANGE: 'CART_DELIVERY_CHANGE',

    PAYMENT_CHANGE: 'CART_PAYMENT_CHANGE',

    CONSENT_CHANGE: 'CONSENT_CHANGE',

    MID_CART_VISIBILITY: 'MID_CART_VISIBILITY'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/action-types.js
// module id = 440
// module chunks = 0 2